import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { ToasterService } from './toaster.service';

@Injectable()
export class ToastInterceptor implements HttpInterceptor {
  constructor(private readonly toaster: ToasterService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap(event => {
        if (
          event instanceof HttpResponse &&
          req.method !== 'GET'
        ) {
          // Skip automatic toast for forgot password endpoint - handled manually in component
          if (req.url.includes('forgot-password')) {
            return;
          }
          this.toaster.showApiResponseToast(event.body);
        }
      })
    );
  }
} 